<template>
  <div class="club-hortense-phone">
    <div class="row">
      <div class="d-flex flex-column align-items-center justify-content-center text-center gap-4 w-100" data-aos="fade-up" data-aos-duration="900">
        <h2 class="merriweather-reg-20">Le Club</h2>
        <h2 class="merriweather-reg-26">Hortense</h2>
        <div class="d-flex flex-column align-items-start justify-content-start text-left px-3">
          <p class="raleway-reg-p15 mb-1">
            Devenez membre du Club Hortense et profitez de privilèges exclusifs :
          </p>
          <ul class="raleway-reg-p15 text-start pl-4 mb-1">
            <li class="text-left">Services offerts : massage relaxant, bouteille de champagne, surclassement ...</li>
            <li class="text-left">Offres promotionnelles : réductions réservées aux membres.</li>
          </ul>
          <p class="raleway-reg-p15 mb-1">
            Un club exclusif qui transforme chaque séjour en expérience d’exception.
          </p>
        </div>
        <div class="pt-4 w-100 px-3">
          <a class="hortense-btn-primary raleway-bold-p13" @click="showModal = true">Rejoindre le club</a>
        </div>
        <a class="raleway-reg-p15 pt-4 link-text" href="/le-club-hortense" target="_blank">En savoir plus sur le Club Hortense</a>
      </div>
      <div class="px-5" @click="goToGroup('/le-club-hortense')" data-aos="fade-up" data-aos-duration="900">
        <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/HP+-+GIF+-+club+hortense+-+720+x+500.gif" alt="Club Hortense" class="img-fluid" />
      </div>
    </div>
    <Modalsignup v-if="showModal" @close="showModal = false"></Modalsignup>
  </div>
</template>
<script>
import Modalsignup from './modals/Modalsignup.vue';
export default {
		name: 'ClubHortense',
    components: { Modalsignup },
		data() {
			return {
        showModal: false,
      };
		},
    methods: {
      goToGroup(url){
        window.open(url, '_blank');
      }
    }
	};
</script>
<style scoped>
.club-hortense-phone {
  padding-top: 40px;

  .row {
    background: rgba(207, 229, 220, 0.2);
    gap: 25px;
    padding-top: 34px;
    padding-right: 16px;
    padding-bottom: 34px;
    padding-left: 16px;

  }

  img {
    width: 100%;
    height: 238px;
    object-fit: cover;
    border-radius: 15px;
  }
  .link-text{
    text-decoration: underline;
    color: black;
  }
  .zoom-img-container {
    border-radius: 15px;
  }
}

</style>